import React, { useContext, useState } from "react";
import { cls } from "cls";
import { Modal } from "@clarkinc/zest-design-system";
import FilterListItem from "./FilterListItem";
import FilterRange from "./FilterRange";
import { SectionGroupItem, SectionGroup } from "./Filters";
import ColorSwatch from "./ColorSwatch";
import Button from "~/common/Buttons";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { FilterModalContext } from "../FilterModalContextProvider";
interface DisplayFilterListItemProps {
  groupItem: SectionGroupItem;
  prefetch?: boolean;
  isCustomFilterRange?: boolean;
}
interface Props {
  group: SectionGroup;
  filterText: string;
  useGroupNameInUrl?: boolean;
  groupsWithMultipleSelections: number;
  prefetch?: boolean;
  pageUrl?: string;
}
const groupNameIsColor = (group: SectionGroup) => {
  return group.groupName.toLowerCase() === "color" || group.groupName.toLowerCase() === "handle color" || group.groupName.toLowerCase() === "frame color" || group.groupName.toLowerCase() === "seat color" || group.groupName.toLowerCase() === "back color";
};
const getSelectedMaxValue = (selectedCustomRange: SectionGroupItem | undefined) => {
  return selectedCustomRange !== undefined ? selectedCustomRange.rangeEndValue?.toString() : "";
};
const getSelectedMinValue = (selectedCustomRange: SectionGroupItem | undefined) => {
  return selectedCustomRange !== undefined ? selectedCustomRange.rangeStartValue?.toString() : "";
};
const getSelectedUnit = (selectedCustomRange: SectionGroupItem | undefined) => {
  return selectedCustomRange !== undefined ? selectedCustomRange.unitOfMeasurement?.toString() : "";
};
const getButtonText = (showAllFilterItems: boolean, group: SectionGroup, splitPoint: number) => {
  return showAllFilterItems ? "Collapse" : `Show ${group.groupItems.length - splitPoint} More`;
};
const FilterListItems = ({
  group,
  filterText,
  useGroupNameInUrl,
  groupsWithMultipleSelections,
  prefetch,
  pageUrl = ""
}: Props) => {
  const [showAllFilterItems, setShowAllFilterItems] = useState(false);
  const selectedItemsInGroup = group.groupItems.filter(groupItem => groupItem.isSelected).length;
  const splitPoint = 8;
  const minimumItemsToDisplayShowMore = 10;
  const DisplayFilterListItem = ({
    groupItem,
    isCustomFilterRange = false
  }: DisplayFilterListItemProps) => <FilterListItem groupItem={groupItem} groupNameEncoded={useGroupNameInUrl ? group.groupNameEncoded : ""} filterText={filterText} groupsWithMultipleSelections={groupsWithMultipleSelections} selectedItemsInGroup={selectedItemsInGroup} prefetch={prefetch} isCustomFilterRange={isCustomFilterRange} data-sentry-element="FilterListItem" data-sentry-component="DisplayFilterListItem" data-sentry-source-file="FilterListItems.tsx" />;
  const handleClick = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setShowAllFilterItems(!showAllFilterItems);
  };
  const {
    compareProductsActive,
    storedFilterUrl
  } = useContext(FilterModalContext);
  const shouldOpenModal = compareProductsActive && storedFilterUrl;
  if (groupNameIsColor(group)) {
    return <>
        {group.groupItems.map(groupItem => <ColorSwatch groupItem={groupItem} selectedItemsInGroup={selectedItemsInGroup} groupsWithMultipleSelections={groupsWithMultipleSelections} key={`${filterText}-${groupItem.label}${groupItem.count}`} prefetch={prefetch} />)}
      </>;
  }
  const selectedCustomRange = group.groupItems.filter(x => x.isSelected && x.isCustomRange)[0];
  const clearRange = () => {
    if (selectedCustomRange) {
      if (shouldOpenModal) {
        Modal.open("confirm-edit-filters-warning");
        // eslint-disable-next-line no-param-reassign
        storedFilterUrl.current.url = selectedCustomRange.filterUrl;
      } else {
        setWindowLocationHref(selectedCustomRange.filterUrl);
      }
    }
  };
  const rangeFilter = group.groupItems[0]?.unitOfMeasurement && group.groupItems.find(x => x.rangeStartValue !== (null || undefined) && !!x.rangeEndValue) ? <FilterRange
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  units={[...new Set(group.groupItems.map(i => i.unitOfMeasurement!))]} pageUrl={pageUrl} group={group} selectedMaxValue={getSelectedMaxValue(selectedCustomRange)} selectedMinValue={getSelectedMinValue(selectedCustomRange)} selectedUnit={getSelectedUnit(selectedCustomRange)} clearCustomFilterRangeUrl={clearRange} /> : null;
  if (group.groupItems.length > minimumItemsToDisplayShowMore) {
    return <>
        {rangeFilter}
        <>
          {group.groupItems.slice(0, splitPoint).map(groupItem => <DisplayFilterListItem groupItem={groupItem} key={`${filterText}-${groupItem.label}${groupItem.count}`} isCustomFilterRange={selectedCustomRange?.isCustomRange} />)}
          <div className={showAllFilterItems ? cls("lt:block") : cls("lt:hidden")} data-component="filterListOverflow">
            {group.groupItems.slice(splitPoint, group.groupItems.length).map(groupItem => <DisplayFilterListItem groupItem={groupItem} key={`${filterText}-${groupItem.label}${groupItem.count}`} isCustomFilterRange={selectedCustomRange?.isCustomRange} />)}
          </div>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Button className={cls("bg-white", "border-gray-400", "hidden", "mx-2-1/2", "mb-2", "mt-1-1/4", "w-11/12", "lt:block", "filter-list__overflow-button")} type="button" color="custom" size="small" data-toggle="filterListOverflow" data-original-text={`Show ${group.groupItems.length - splitPoint} More`} onClick={handleClick}>
            {getButtonText(showAllFilterItems, group, splitPoint)}
          </Button>
        </>
      </>;
  }
  return <>
      {rangeFilter}
      {group.groupItems.map(groupItem => <DisplayFilterListItem key={`${filterText}-${groupItem.label}${groupItem.count}`} groupItem={groupItem} prefetch={prefetch} isCustomFilterRange={selectedCustomRange?.isCustomRange} />)}
    </>;
};
export default FilterListItems;